import React, { useState, useEffect } from "react";
import { Modal, Input, Checkbox, Button, Row, Col, Form, Select } from "antd";
import { coptData } from "../../../../../Data/data"; // Your new COPT data

const { Option } = Select;

const AddCoptDetailsModal = ({ visible, onOk, onCancel, responseData, errors }) => {
  const [form] = Form.useForm();
  const [selectedParams, setSelectedParams] = useState([]);
  const [customParams, setCustomParams] = useState([]);
  const [selectedSection, setSelectedSection] = useState("");

  const safeOptions =
    Array.isArray(coptData) && coptData.length > 0 ? coptData : [];

  // Load default data on open
  useEffect(() => {
    if (responseData) {
      const {
        selected_parameters = [],
        copt_name,
        copt_maker,
        copt_model,
        machinery_type,
        other_parameters,
      } = responseData;

      setSelectedParams(selected_parameters);
      setSelectedSection(machinery_type);
      setCustomParams(Array.isArray(other_parameters) ? other_parameters : []);

      form.setFieldsValue({
        copt_name,
        copt_maker,
        copt_model,
        machinery_type,
      });
    } else {
      form.resetFields();
      setSelectedParams([]);
      setCustomParams([]);
      setSelectedSection("");
    }
  }, [responseData, form]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const fieldErrors = Object.keys(errors).map((key) => ({
        name: key,
        errors: [errors[key]],
      }));
      form.setFields(fieldErrors);
    }
  }, [errors, form]);

  const handleAddParam = () => {
    setCustomParams([...customParams, { name: "", unit: "" }]);
  };

  const handleCustomChange = (index, field, value) => {
    const updated = [...customParams];
    updated[index][field] = value;
    setCustomParams(updated);
  };

  const handleDeleteParam = (index) => {
    setCustomParams(customParams.filter((_, i) => i !== index));
  };

  const handleSectionChange = (value) => {
    setSelectedSection(value);
    const sectionObj = coptData.find((item) => item.label === value);
    setSelectedParams(sectionObj ? sectionObj.parameters : []);
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const data = {
          ...values,
          selectedParams,
          customParams,
        };
        onOk(data);
        form.resetFields();
        setSelectedParams([]);
        setCustomParams([]);
        setSelectedSection("");
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  const renderParameters = (parameters) => (
    <Row gutter={16}>
      {parameters.map((item, index) => (
        <Col span={12} key={index}>
          <Checkbox
            checked={selectedParams.includes(item)}
            onChange={() => handleCheckbox(item)}
          >
            {item}
          </Checkbox>
        </Col>
      ))}
    </Row>
  );

  const handleCheckbox = (item) => {
    setSelectedParams((prev) =>
      prev.includes(item)
        ? prev.filter((param) => param !== item)
        : [...prev, item]
    );
  };

  const renderCustomParameters = () => (
    <div style={{ marginTop: 16 }}>
      <b>Add Other Parameters</b>
      {customParams.map((param, index) => (
        <Row gutter={8} key={index} style={{ marginTop: 8 }}>
          <Col span={10}>
            <Input
              placeholder="Parameter"
              value={param.name}
              maxLength={50}
              onChange={(e) =>
                handleCustomChange(index, "name", e.target.value)
              }
            />
          </Col>
          <Col span={10}>
            <Input
              placeholder="Unit"
              value={param.unit}
              maxLength={10}
              onChange={(e) =>
                handleCustomChange(index, "unit", e.target.value)
              }
            />
          </Col>
          <Col span={4}>
            <Button danger onClick={() => handleDeleteParam(index)} block>
              ×
            </Button>
          </Col>
        </Row>
      ))}
      <Button type="dashed" onClick={handleAddParam} style={{ marginTop: 12 }}>
        + Add Parameter
      </Button>
    </div>
  );

  return (
    <Modal
      title="Add COPT Details"
      visible={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText="Save"
    >
      <Form
        layout="vertical"
        form={form}
        onValuesChange={(changedValues) => {
          Object.keys(changedValues).forEach((key) => {
            form.setFields([{ name: key, errors: [] }]);
          });
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              label="Copt Name"
              name="copt_name"
              rules={[{ required: true }]}
            >
              <Input placeholder="Copt Name" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Copt Maker" name="copt_maker">
              <Input placeholder="Copt Maker" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Copt Model" name="copt_model">
              <Input placeholder="Copt Model" maxLength={50} />
            </Form.Item>
          </Col>

          {/* Add Select field for Machinery Type */}
          <Col span={24}>
            <Form.Item
              label="Machinery Type"
              name="machinery_type"
              rules={[{ required: true }]}
            >
              <Select
                placeholder="Select Machinery Type"
                onChange={handleSectionChange}
                value={selectedSection}
              >
                {safeOptions.map((item) => (
                  <Option key={item.label} value={item.label}>
                    {item.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {selectedSection && (
            <Col span={24}>
              <Form.Item label="Parameters in Selected Section">
                {renderParameters(
                  safeOptions.find((item) => item.label === selectedSection)
                    ?.parameters || []
                )}
              </Form.Item>
            </Col>
          )}

          <Col span={24}>{renderCustomParameters()}</Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddCoptDetailsModal;
